function LoginClient({
  email,
  password,
  error,
  onEmailChange,
  onPasswordChange,
  onSubmit
}) {
  return (
    <div className="ClientLoginPage">
      <div className="Card ClientLoginCard">
        <h1 className="Title">Strona w budowie</h1>
        <p className="Subtitle">Użyj e-maila i hasła, aby kontynuować, które otrzymałeś od administratora.</p>

        <form className="Form" onSubmit={onSubmit}>
          <label className="Field">
            <span className="Label">E-mail</span>
            <input
              className="Input"
              type="email"
              autoComplete="email"
              value={email}
              onChange={onEmailChange}
              required
            />
          </label>

          <label className="Field">
            <span className="Label">Hasło</span>
            <input
              className="Input"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={onPasswordChange}
              required
            />
          </label>

          {error ? <p className="Error">{error}</p> : null}

          <button className="Button" type="submit">
            Zaloguj się
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginClient;
